import { LogoWithVerticalText, Share } from "assets/svg";
import { FormattedMessage } from "react-intl";
import { TTemplate } from "./Templates.types";
import { Link } from "react-router-dom";
import ChangeLanguageButton from "components/theme/ChangeLanguageButton";

export default function Birthday({
  bannerUrl,
  titleFontFamily,
  titleFontSize,
  titleOneText,
  titleOneShadowClass,
  titleTwoText,
  subtitleText,
  buttonTextColor = "#272727",
  wrapperClass,
  templateColor,
  onShare,
  onCapsulaLandingPageClick,
  actionButtonLabel,
  onClick,
}: TTemplate) {
  return (
    <div
      className={`${wrapperClass} max-h-[100vh] template-container overflow-x-hidden flex flex-col items-center bg-white bg-contain bg-bottom bg-no-repeat bg-cover`}
    >
      <div className="relative birthday-banner">
        <img
          className="aspect-square object-cover w-full h-full"
          src={bannerUrl}
          alt="banner-home"
        />
      </div>
      <div className="px-5 relative z-10 mt-8 mb-4">
        <h6
          data-shadow={titleOneText}
          className={`${titleFontFamily} ${titleOneShadowClass}  text-theme-black font-normal text-center relative before:content-[attr(data-shadow)] before:absolute before:z-[-1] before:top-[-0.25em] before:left-[-0.5em] before:text-[1.5em] before:opacity-[0.2] before:whitespace-nowrap ${
            titleFontFamily === "font-high-spirited" ? "leading-none" : ""
          }`}
          style={{
            fontSize: titleFontSize,
          }}
          translate="no"
        >
          {titleOneText}
        </h6>
        {titleTwoText && (
          <h6
            className={`${titleFontFamily} text-theme-black font-normal text-center leading-none`}
            style={{
              fontSize:
                titleFontFamily === "font-high-spirited"
                  ? parseInt(titleFontSize.replace("px", "")) * 0.7 + "px"
                  : parseInt(titleFontSize.replace("px", "")) * 0.5 + "px",
            }}
            translate="no"
          >
            {titleTwoText}
          </h6>
        )}
      </div>
      <div className="flex flex-col items-center px-[60px] mt-2 mb-7">
        <p className="font-century-gothic text-sm">{subtitleText}</p>
      </div>
      <div className="flex items-center justify-center gap-4 px-4 mb-8">
        <ChangeLanguageButton
          template="birthday"
          templateColor={templateColor}
          buttonTextColor={buttonTextColor}
        />

        <button
          onClick={onClick}
          type="button"
          className={`${templateColor} shadow-md shadow-gray-300 font-century-gothic-bold text-sm rounded-[10px] h-10 px-10 flex-auto flex whitespace-nowrap justify-center items-center`}
          style={{
            color: buttonTextColor,
          }}
        >
          {actionButtonLabel}
        </button>

        <button
          onClick={onShare}
          type="button"
          className={`${templateColor} shadow-md shadow-gray-300 font-century-gothic-bold text-sm rounded-full p-3 h-10 w-10 flex justify-center items-center`}
        >
          <Share
            width={20}
            height={20}
            outline={buttonTextColor}
            color={buttonTextColor}
          />
        </button>
      </div>
      <div className="text-terms bg-white px-2">
        <FormattedMessage
          id="message.termsOfUse"
          defaultMessage="Ao utilizar nosso sistema você concorda com nossos <code>Termos de Uso</code>"
          values={{
            code: (text) => (
              <Link to="/terms" className="underline text-terms">
                {text}
              </Link>
            ),
          }}
        />
      </div>

      <div className="flex justify-center items-center mt-5 mb-2 bg-white">
        <button onClick={onCapsulaLandingPageClick} type="button">
          <LogoWithVerticalText
            width={115}
            height={17}
            color="black"
            outline="black"
          />
        </button>
      </div>
    </div>
  );
}
